var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(" "+_vm._s(this.passage_name)+" ")]),_c('span',{domProps:{"innerHTML":_vm._s(this.bible)}}),_c('br'),_c('br'),_vm._v("\n  Link:     "+_vm._s(this.link)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }